import React, { useState, useEffect, useRef } from "react";
import { Tag, Input, Button } from 'antd';
import { FORM_LANG, formText } from '../../constants/form-i18n';
import { TweenOneGroup } from 'rc-tween-one';
import { PlusOutlined } from '@ant-design/icons';

const EditableTagGroup = ({ ...props }) => {
	const [inputVisible, setInputVisible] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [confirmTag, setConfirmTag] = useState(false);
	const [tag, setTag] = useState([]);
	const tagInputRef = useRef();

	useEffect(() => {
		if (inputVisible) {
			tagInputRef.current.focus();
		}
	}, [inputVisible]);

	useEffect(() => {
		if (confirmTag && !inputVisible && inputValue === '') {
			props.onChange(tag);
		}
	}, [inputValue, inputVisible, confirmTag, tag]);

	const handleClose = (removedTag) => {
		const tags = props.tags.filter((tag) => tag !== removedTag);
		props.onChange(tags);
	}

	const showInput = () => {
		setInputVisible(true, () => this.tagInputRef.focus());
		// this.setState({ inputVisible: true }, () => this.input.focus());
	}

	const handleInputChange = (e) => {
		setInputValue(e.target.value);
		// this.setState({ inputValue: e.target.value });
	}

	const handleInputConfirm = () => {
		let { tags } = props;
		if (inputValue && tags.indexOf(inputValue) === -1) {
			tags = [...tags, inputValue];
		}

		setConfirmTag(true);
		setInputVisible(false);
		setInputValue('');
		setTag(tags);
	}

	// const saveInputRef = (input) => {
	// 	this.input = input;
	// }

	const forMap = (tag) => {
		const tagElem = (
			<Tag
				closable
				onClose={(e) => {
					e.preventDefault();
					handleClose(tag);
				}}>
				{tag}
			</Tag>
		);
		return (
			<span key={tag} style={{ display: 'inline-block' }}>
				{tagElem}
			</span>
		);
	}

	const { tags } = props;
	const tagChild = tags.map(forMap);

	return (
		<>
			<div style={{ marginBottom: 16 }}>
				{inputVisible && (
					<Input
						ref={tagInputRef}
						type="text"
						style={{ width: 78 }}
						value={inputValue}
						onChange={handleInputChange}
						onBlur={handleInputConfirm}
						onPressEnter={handleInputConfirm}
					/>
				)}
				{!inputVisible && (
					// <Tag onClick={this.showInput} className="site-tag-plus">
					// 	<PlusOutlined /> เพิ่มคีย์เวิร์ด
					// </Tag>

					<Button
						type="dashed"
						style={{ width: props.customWidth ? props.customWidth : "20%" }}
						icon={<PlusOutlined className="transform-nmu" />}
						onClick={showInput} className="site-tag-plus"
					>
						{/* NMU-444: follows the dialog's active tab language. */}
						{formText(props.lang || FORM_LANG.TH)('addKeyword')}
					</Button>
				)}
				<div style={{ float: 'left' }}>
					<TweenOneGroup
						enter={{
							scale: 0.8,
							opacity: 0,
							type: 'from',
							duration: 100,
							onComplete: (e) => {
								e.target.style = '';
							},
						}}
						leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
						appear={false}>
						{tagChild}
					</TweenOneGroup>
				</div>
			</div>
		</>
	);
}

export default EditableTagGroup;

// class EditableTagGroup extends Component {
// 	constructor() {
// 		super();
// 		this.state = {
// 			inputVisible: false,
// 			inputValue: '',
// 		};
// 		this.showInput = this.showInput.bind(this);
// 		this.handleClose = this.handleClose.bind(this);
// 		this.handleInputChange = this.handleInputChange.bind(this);
// 		this.handleInputConfirm = this.handleInputConfirm.bind(this);
// 		this.saveInputRef = this.saveInputRef.bind(this);
// 		this.forMap = this.forMap.bind(this);
// 	}

// 	handleClose(removedTag) {
// 		const tags = this.props.tags.filter((tag) => tag !== removedTag);
// 		this.props.onChange(tags);
// 	}

// 	showInput() {
// 		this.setState({ inputVisible: true }, () => this.input.focus());
// 	}

// 	handleInputChange(e) {
// 		this.setState({ inputValue: e.target.value });
// 	}

// 	handleInputConfirm() {
// 		const { inputValue } = this.state;
// 		let { tags } = this.props;
// 		if (inputValue && tags.indexOf(inputValue) === -1) {
// 			tags = [...tags, inputValue];
// 		}
// 		this.setState(
// 			{
// 				inputVisible: false,
// 				inputValue: '',
// 			},
// 			() => {
// 				console.log('test' , tags);
// 				this.props.onChange(tags);
// 			}
// 		);
// 	}

// 	saveInputRef(input) {
// 		this.input = input;
// 	}

// 	forMap(tag) {
// 		const tagElem = (
// 			<Tag
// 				closable
// 				onClose={(e) => {
// 					e.preventDefault();
// 					this.handleClose(tag);
// 				}}>
// 				{tag}
// 			</Tag>
// 		);
// 		return (
// 			<span key={tag} style={{ display: 'inline-block' }}>
// 				{tagElem}
// 			</span>
// 		);
// 	}

// 	render() {
// 		const { inputVisible, inputValue } = this.state;
// 		const { tags } = this.props;
// 		const tagChild = tags.map(this.forMap);
// 		return (
// 			<>
// 				<div style={{ marginBottom: 16 }}>
// 					{inputVisible && (
// 						<Input
// 							ref={this.saveInputRef}
// 							type="text"
// 							style={{ width: 78 }}
// 							value={inputValue}
// 							onChange={this.handleInputChange}
// 							onBlur={this.handleInputConfirm}
// 							onPressEnter={this.handleInputConfirm}
// 						/>
// 					)}
// 					{!inputVisible && (
// 						// <Tag onClick={this.showInput} className="site-tag-plus">
// 						// 	<PlusOutlined /> เพิ่มคีย์เวิร์ด
// 						// </Tag>

// 						<Button
// 							type="dashed"
// 							style={{ width: this.props.customWidth ? this.props.customWidth :"20%" }}
// 							icon={<PlusOutlined className="transform-nmu" />}
// 							onClick={this.showInput} className="site-tag-plus"
// 						>
//                         เพิ่มคีย์เวิร์ด
//                       </Button>
// 					)}
// 					<div style={{ float: 'left' }}>
// 						<TweenOneGroup
// 							enter={{
// 								scale: 0.8,
// 								opacity: 0,
// 								type: 'from',
// 								duration: 100,
// 								onComplete: (e) => {
// 									e.target.style = '';
// 								},
// 							}}
// 							leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
// 							appear={false}>
// 							{tagChild}
// 						</TweenOneGroup>
// 					</div>
// 				</div>
// 			</>
// 		);
// 	}
// }

// EditableTagGroup.propTypes = {
// 	tags: PropTypes.array,
// 	onChange: PropTypes.func,
// };

// EditableTagGroup.defaultProps = {
// 	tags: [],
// 	onChange: (tags) => {
// 		console.error(tags);
// 	},
// };

